import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { trackPartnerRegisterStarted } from 'register-partners-js/utils/consent-ab';

export default class WelcomeIndexRoute extends Route {
  mainLayout = MainLayout;

  @service segment;

  activate() {
    let {
      partnerName,
      organizationLegalCountry = 'FR',
      legalFlow = 'company_creation',
      organizationId,
    } = this.modelFor('welcome').redirection;

    let isFrEmbedQf = legalFlow === 'qonto_invoicing';

    trackPartnerRegisterStarted(this.segment, {
      organizationLegalCountry,
      legalFlow,
      organizationId,
      partnerName,
    });
    this.segment.track('onboarding_partner_register_eligibility_confirmed', {
      ...(isFrEmbedQf && { flow: 'fr_embed_qf' }),
    });
  }
}
